import { render } from "./DataCreateForm.vue?vue&type=template&id=17984fb8"
import script from "./DataCreateForm.vue?vue&type=script&lang=js"
export * from "./DataCreateForm.vue?vue&type=script&lang=js"

import "./DataCreateForm.vue?vue&type=style&index=0&id=17984fb8&lang=scss"

import exportComponent from "D:\\Programmierung\\Senckenberg\\Socotra\\Socotra-Demo-Vue-Offline-SrcData\\socotra-vue-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__